// extracted by mini-css-extract-plugin
export default {"list":"ListItem_list__6xG-4","info":"ListItem_info__fLESO","name":"ListItem_name__zGg1A","rating":"ListItem_rating__-kEvk"};